import { Section } from '@advanza/advanza_generic'
import Page from 'components/ui/Page'
import React from 'react'
import MatchFilter from './MatchFilter'
import MatchList from './MatchList'

class MatchesPage extends React.Component {
    render() {
        return (
            <Page title="Matches">
                <div className="container">
                    <Section w>
                        <h1>Matches</h1>
                    </Section>
                    <Section y>
                        <MatchFilter
                            filterId="all"
                            defaultOptions={{ pageSize: 40 }}
                            hidePagination
                        />
                    </Section>
                    <MatchList filterId="all" />
                </div>
            </Page>
        )
    }
}
export default MatchesPage
